module.exports = __webpack_public_path__ + "img/Rockwell Automation1.e0e6f074.png";